// src/utils/constants.js

// client/src/data/constants.js

export const lagosLGAs = [
  'Agege','Ajeromi-Ifelodun','Alimosho','Amuwo-Odofin','Apapa','Badagry',
  'Epe','Eti-Osa','Ikeja','Ikorodu','Kosofe','Lagos Island','Lagos Mainland',
  'Mushin','Ojo','Oshodi-Isolo','Shomolu','Surulere','Ifako-Ijaiye','Ibeju-Lekki'
];

export const jobTypes = [
  'Electrician','Plumber','Bricklayer','Carpenter','Painter','Tiler','Solar Installer',
  'Welder','Mechanic','AC/Fridge Repair','Generator Technician','ICT Support',
  'Phone Repair','CCTV Installer','Satellite Dish Installer'
];

// Color palette
export const COLORS = {
  primary: '#4CAF50',
  secondary: '#2196F3',
  danger: '#f44336',
  warning: '#FFC107',
  text: '#333333',
  background: '#f9f9f9',
  border: '#cccccc',
};
